import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SearchService } from '../../services/search.service';
import { map, take } from 'rxjs/operators';

/**
 * Booking Guard
 * 
 * Bu guard, kullanıcının aktif bir arama/rezervasyon işlemi olup olmadığını kontrol eder.
 * Eğer search verisi yoksa, kullanıcı ana sayfaya yönlendirilir.
 * 
 * Korunan sayfalar: /yolcu-bilgileri
 */
export const bookingGuard: CanActivateFn = (route, state) => {
  const searchService = inject(SearchService);
  const router = inject(Router);

  // URL'den productKey kontrolü
  const productKey = route.queryParams['productKey'];
  
  // SessionStorage'dan search verisi kontrolü
  const hasSearchData = sessionStorage.getItem('pusula_search_results');
  
  // SearchService'den anlık kontrol
  return searchService.searchResults$.pipe(
    take(1),
    map(results => {
      // productKey varsa ve search verisi varsa izin ver
      if (productKey && (results || hasSearchData)) {
        return true;
      }
      
      // Search verisi varsa izin ver (productKey URL'de olabilir)
      if (results?.items?.length && results.items.length > 0 || hasSearchData) {
        return true;
      }

      // Hiçbir veri yoksa ana sayfaya yönlendir
      router.navigate(['/']);
      return false;
    })
  );
};
